import { driver, DriveStep } from "driver.js";
import "driver.js/dist/driver.css";

interface Params {
  stepts: DriveStep[]
}

const driverObj = driver();

export const useDriver = ({ stepts }: Params) => {
  const initTutorial = () => {
    driverObj.setSteps(stepts);
    driverObj.drive();
  };

  return {
    initTutorial
  };
};